export const APP_ROUTES = {
  index: '/',
  login: '/login',
  loginUser: '/login-user',
  loginUaePass: '/login-uaepass',
  signUp: '/sign-up',
  app: {
    index: '/app',
    onboarding: '/app/onboarding',
    analysis: '/app/360-analysis',
    dataImport: {
      index: '/app/data-import',
      addData: '/app/data-import/add',
    },
    settings: {
      index: '/app/settings',
      company: '/app/settings/company',
      notifications: '/app/settings/notifications',
      connectCrm: '/app/settings/connect-crm',
    },
    aiChat: '/app/ai-chat',
  },
} as const;
